import { AccountCircle, Assignment, CheckCircle, Close, Description, OpenInNew, QuestionAnswer, ReceiptLong, WarningAmber } from '@mui/icons-material';
import { Alert, Avatar, Box, Button, Chip, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, FormControl, Grid, IconButton, InputLabel, LinearProgress, MenuItem, Paper, Select, Snackbar, Stack, Table, TableBody, TableCell, TableContainer, TableRow, TextField, Typography } from '@mui/material';
import React, { Component } from 'react';
import "./CreateOrder.css";
import axios from 'axios';
import Global from "../../customlib/Global";
import Api from "../../customlib/Api";
import PoinCheckoutLinkSection from "./PoinCheckoutLinkSection";
import Dropzone from 'react-dropzone';
import base64 from "base-64";
import moment from 'moment';
import ImageZoom from 'react-medium-image-zoom';
import { CustomerFlagCard } from '../CrmLiveChat/CustomerFlagSection';
import SubOrderChip from './SubOrderChip';

class CustomerProfile extends Component {
    state = { 
        dataOrder: {
            customerId: 0,
            customerEmail: "",
            customerPhone: "",
            customerName: "",
            memberStatus: "",
            customerType: "",
            customerGender: "",
            jenisPertanyaan: "",
            levelCustomer: "",
            jawabanCustomer: "",
            kesimpulanJawabanCustomer: ""
        },
        listCountry: [],
        listProvince: [],
        listCity: [],
        keyword: "",
        page: 1,
        customLogoFile: null,
        customLogoBase64: null,
        customDesignFile: null,
        customDesignBase64: null,
        extractedDataOrder: null,
        showSnackbar: false,
        snackbarMessage: "",
        isLoadingCustomerInfo: false,
        isDialogNotFoundOpen: false,
        isSubmitting: false,
        showDialogSubmitSuccess: false,
        customerLevel: "",
        customerAnsweredQna: 0,
        listQna: [],
        isLoadingCustomerQna: true,
        lastOrderInfo: null,
        hMinValue: "",
        listRekomendasiHsm: [],
        lastOrderDocuments: []
    } 

    toggleDialogNotFound = () => {
        let isDialogOpen = this.state.isDialogNotFoundOpen;
        if(isDialogOpen){
            this.props.onCloseDrawer();
        }
        this.setState({isDialogNotFoundOpen: !isDialogOpen});
    }

    toggleDialogSubmitSuccess = () => {
        let isDialogOpen = this.state.showDialogSubmitSuccess;
        if(isDialogOpen){
            this.props.onCloseDrawer();
        }
        this.setState({showDialogSubmitSuccess: !isDialogOpen});
    }

    componentDidUpdate(prevProps, prevState) {
        if(prevProps.waNumber !== this.props.waNumber){
            console.log("UPDATED_PROPS", prevProps, this.props);
            
            this.init();
        }
    }

    loadCustomerInfo = () => {
        this.setState({isLoadingCustomerInfo: true}, () => {
            axios
                .get(Api.lavenderGetCustomerInfo(this.state.dataOrder.customerEmail, this.state.dataOrder.customerPhone), Api.getRequestHeaderNoAuth())
                // .get(Api.lavenderGetCustomerInfo("kekeke", "wkwkw"), Api.getRequestHeaderNoAuth())
                .then((response) => {
                    console.log("CUSTOMER_INFO : ", response.data);
                    let data = response.data;

                    if(data){
                        let dataOrder = {...this.state.dataOrder};
                        dataOrder.customerEmail = data.email;
                        dataOrder.customerPhone = data.phone;
                        dataOrder.customerName = data.name;
                        dataOrder.memberStatus = data.is_member;
                        dataOrder.customerType = data.type;
                        dataOrder.customerGender = data.gender;
                        dataOrder.customerId = parseInt(data.id);
                        dataOrder.points = data.points;
                        this.setState({dataOrder: dataOrder, isLoadingCustomerInfo: false});
                    }else{
                        // this.handleShowSnackbar("Customer dengan \nemail: " + this.state.dataOrder.customerEmail + " dan \nphone: " + this.state.dataOrder.customerPhone + "\n tidak ditemukan");
                        this.setState({isLoadingCustomerInfo: false});
                        // this.toggleDialogNotFound();
                    }

                    // this.setState({listProduct: data, isLoadingSearch: false});
                })
                .catch((error) => {
                    this.setState({isLoadingCustomerInfo: false});
                    console.error("There was an error!", error);
                });
        })
        
    };

    loadlastOrderDocuments = () => {
        this.setState({isLoadingLastOrderDocuments: true}, () => {
            axios
                .get(Api.companyLastOrderDocuments(this.props.waNumber), Api.getRequestHeaderJson())
                // .get(Api.lavenderGetCustomerInfo("kekeke", "wkwkw"), Api.getRequestHeaderNoAuth())
                .then((response) => {
                    console.log("CUSTOMER_INFO : ", response.data);
                    let data = response.data;

                    this.setState({lastOrderDocuments: data.data, isLoadingLastOrderDocuments: false}, () => {
                        console.log("LASTORDERDOCS", this.state.lastOrderDocuments);
                    });

                    // this.setState({listProduct: data, isLoadingSearch: false});
                })
                .catch((error) => {
                    this.setState({isLoadingLastOrderDocuments: false});
                    console.error("There was an error!", error);
                });
        })
        
    };

    loadCustomerQna = () => {
        this.setState({isLoadingCustomerQna: true}, () => {
            axios
                .get(Api.lavenderGetCustomerQna(this.state.dataOrder.customerPhone), Api.getRequestHeaderNoAuth())
                // .get(Api.lavenderGetCustomerInfo("kekeke", "wkwkw"), Api.getRequestHeaderNoAuth())
                .then((response) => {
                    console.log("CUSTOMER_INFO : ", response.data);
                    let responseData = response.data;

                    if(responseData){
                        const custData = responseData.data;
                        let level = custData.profileCustomer?.level ?? "-";
                        let answeredQna = custData.profileCustomer?.total_answered_question ?? 0;
                        let listQna = custData.listQna ?? [];
                        let lastOrderInfo = custData.lastOrder;

                        this.setState({customerLevel: level, customerAnsweredQna: answeredQna, listQna: listQna, lastOrderInfo: lastOrderInfo, isLoadingCustomerQna: false}, () => {
                            console.log("LASTORDER", this.state.lastOrderInfo);
                        });

                    }else{
                        // this.handleShowSnackbar("Customer dengan \nemail: " + this.state.dataOrder.customerEmail + " dan \nphone: " + this.state.dataOrder.customerPhone + "\n tidak ditemukan");
                        // this.setState({isLoadingCustomerInfo: false});
                        // this.toggleDialogNotFound();
                        this.setState({isLoadingCustomerQna: false});
                    }

                    // this.setState({listProduct: data, isLoadingSearch: false});
                })
                .catch((error) => {
                    this.setState({isLoadingCustomerQna: false});
                    console.error("There was an error!", error);
                });
        })
        
    };


    handleProceed = () => {

        let customerEmail = this.state.dataOrder.customerEmail;
        let customerPhone = this.state.dataOrder.customerPhone;
        let customerName = this.state.dataOrder.customerName;
        let customerGender = this.state.dataOrder.customerGender;
        let jenisPertanyaan = this.state.dataOrder.jenisPertanyaan;
        let kesimpulanJawabanCustomer = this.state.dataOrder.kesimpulanJawabanCustomer;


        if(customerEmail?.trim().length <= 0){
            this.handleShowSnackbar("Customer Email belum diisi");
            return;
        }

        if(!Global.isEmailValid(customerEmail)){
            this.handleShowSnackbar("Email tidak valid");
            return;
        }

        if(customerPhone?.trim().length <= 0){
            this.handleShowSnackbar("Customer Phone belum diisi");
            return;
        }

        if(!Global.isPhoneValid(customerPhone)){
            this.handleShowSnackbar("Customer phone tidak valid");
            return;
        }

        if(customerName?.trim().length <= 0){
            this.handleShowSnackbar("Customer Name belum diisi");
            return;
        }

        if(customerGender?.trim().length <= 0){
            this.handleShowSnackbar("Customer Gender belum diisi");
            return;
        }

        if(jenisPertanyaan?.trim().length <= 0){
            this.handleShowSnackbar("Jenis pertanyaan belum dipilih");
            return;
        }

        if(kesimpulanJawabanCustomer?.trim().length <= 0){
            this.handleShowSnackbar("Kesimpulan jawaban customer belum diisi");
            return;
        }

        this.handleOpenLavender();

    }

    handleShowSnackbar = (message) => {
        this.setState({showSnackbar: true, snackbarMessage: message});
    }

    handleOpenLavender = () => {        

        this.setState({isSubmitting: true}, () => {
            
            let payload = {
                customer_id : this.state.dataOrder.customerId,
                question : this.state.dataOrder.jenisPertanyaan,
                level : this.state.dataOrder.levelCustomer,
                answer : this.state.dataOrder.jawabanCustomer,
                conclusion : this.state.dataOrder.kesimpulanJawabanCustomer
              }

            axios
                .post(Api.lavenderSubmitCustomerProfile(), payload, Api.getRequestHeaderNoAuth())
                .then((response) => {
                    
                    let data = response.data;

                    if(data && data.success === true){
                        // this.handleShowSnackbar("Customer profile berhasil disubmit, akan segera direview");
                        this.setState({isSubmitting: false, showDialogSubmitSuccess: true});
                        // this.props.onCloseDrawer();
                    }else{
                        this.handleShowSnackbar(data.msg);
                        this.setState({isSubmitting: false});
                    }
                    
                })
                .catch((error) => {
                    this.setState({isSubmitting: false});
                });
        })

        // console.log("PAYLOAD", payload);
        // let payloadBase64 = base64.encode(JSON.stringify(payload));
        // console.log("PAYLOAD", payloadBase64);

        // var url = Api.getLavenderUrl() + "https://lavender.prestisa.id/api/service/0efade19437fb381e3526380bc53659c/customer-profile/create" + payloadBase64;
        // var win = window.open(url, '_blank');
        // win.focus();

    }

    LEVEL_CUSTOMER = [
        "Customer",
        "Teman",
        "Sahabat",
        "Keluarga"
    ]

    JENIS_PERTANYAAN = [
        { userType: "SALES", question: "Nama", parent: "" },
        { userType: "SALES", question: "Jenis kelamin", parent: "" },
        { userType: "SALES", question: "Email", parent: "" },
        { userType: "SALES", question: "No telepon", parent: "" },
        { userType: "SALES", question: "Alamat kantor", parent: "" },
        { userType: "SALES", question: "Kota alamat kantor", parent: "" },

        { userType: "CS", question: "Masalah yang sedang dihadapi", parent: "" },
        { userType: "CS", question: "Tanggapan terhadap produk prestisa", parent: "" },
        { userType: "CS", question: "Saran perbaikan", parent: "" },

        { userType: "TELEMARKETING", question: "Respon terhadap promo", parent: "Customer" },
        { userType: "TELEMARKETING", question: "Loyalitas pembelian", parent: "Customer" },
        { userType: "TELEMARKETING", question: "Produk yang sering dicari", parent: "Customer" },
        { userType: "TELEMARKETING", question: "Faktor pembelian", parent: "Customer" },
        { userType: "TELEMARKETING", question: "Apa alasan customer belum melakukan pembelian dalam bulan ini ?", parent: "Customer" },

        { userType: "TELEMARKETING", question: "Alamat rumah (personal)", parent: "Teman" },
        { userType: "TELEMARKETING", question: "Kota alamat rumah (personal)", parent: "Teman" },
        { userType: "TELEMARKETING", question: "Pendidikan terakhir", parent: "Teman" },
        { userType: "TELEMARKETING", question: "Jumlah anak", parent: "Teman" },
        { userType: "TELEMARKETING", question: "Anak sekolah dimana", parent: "Teman" },
        { userType: "TELEMARKETING", question: "Anak kelas berapa", parent: "Teman" },
        { userType: "TELEMARKETING", question: "Jenis kelamin anak", parent: "Teman" },
        { userType: "TELEMARKETING", question: "Karakteristik customer", parent: "Teman" },
        { userType: "TELEMARKETING", question: "Keyakinan customer", parent: "Teman" },
        { userType: "TELEMARKETING", question: "Sosial media", parent: "Teman" },
        
        { userType: "TELEMARKETING", question: "Pekerjaan (divisi)", parent: "Sahabat" },
        { userType: "TELEMARKETING", question: "Status pernikahan", parent: "Sahabat" },
        { userType: "TELEMARKETING", question: "Hobi", parent: "Sahabat" },
        { userType: "TELEMARKETING", question: "Tanggal lahir", parent: "Sahabat" },
        { userType: "TELEMARKETING", question: "Jam kantor", parent: "Sahabat" },
        { userType: "TELEMARKETING", question: "Jam kegiatan", parent: "Sahabat" },
        { userType: "TELEMARKETING", question: "Pembelian tiket kegiatan", parent: "Sahabat" },
        { userType: "TELEMARKETING", question: "Budget hobi", parent: "Sahabat" },
        { userType: "TELEMARKETING", question: "Notes hobi", parent: "Sahabat" },
        { userType: "TELEMARKETING", question: "Suku", parent: "Sahabat" },
        { userType: "TELEMARKETING", question: "Pekerjaan pasangan", parent: "Sahabat" },
        { userType: "TELEMARKETING", question: "Kota kantor pasangan", parent: "Sahabat" },
        { userType: "TELEMARKETING", question: "Notes pernikahan", parent: "Sahabat" },
        { userType: "TELEMARKETING", question: "Brand yang dipakai", parent: "Sahabat" },

        { userType: "TELEMARKETING", question: "Notes ayah customer", parent: "Keluarga" },
        { userType: "TELEMARKETING", question: "Notes ibu customer", parent: "Keluarga" },
        { userType: "TELEMARKETING", question: "Notes saudara customer", parent: "Keluarga" },
        { userType: "TELEMARKETING", question: "Hobi pasangan", parent: "Keluarga" },
        { userType: "TELEMARKETING", question: "Hobi anak", parent: "Keluarga" }
        // {
        //     userType: "SALES",
        //     questionsType: [
                
        //     ]
        // },
        // {
        //     userType: "CS",
        //     questionsType: [
                
        //     ]
        // },
        // {
        //     userType: "TELEMARKETING",
        //     questionsType: [
        //         ,
        //     ]
        // }
    ];

    getJenisPertanyaan = () => {
        if(Global.isTeleCutomer()){
            return this.JENIS_PERTANYAAN.filter(item => item.userType === "TELEMARKETING");
        }else if(Global.isCustomerService()){
            return this.JENIS_PERTANYAAN.filter(item => item.userType === "CS");
        }else if(Global.isSales()){
            return this.JENIS_PERTANYAAN.filter(item => item.userType === "SALES");
        }else{
            return this.JENIS_PERTANYAAN;
        }
    }

    CUSTOMER_TYPES = [
        {
            id: 0,
            name: "Personal"
        },
        {
            id: 1,
            name: "Corporation"
        }
    ];

    MEMBER_STATUS = [
        {
            id: 0,
            name: "Bukan Member"
        },
        {
            id: 1,
            name: "Member"
        }
    ];

    GENDER = [
        {
            id: "Female",
            name: "Female"
        },
        {
            id: "Male",
            name: "Male"
        }
    ];

    handleCustomerEmailChange = (event) => {
        let dataOrder = {...this.state.dataOrder};
        dataOrder.customerEmail = event.target.value;
        this.setState({dataOrder: dataOrder});
    }

    handleCustomerPhoneChange = (event) => {
        let dataOrder = {...this.state.dataOrder};
        dataOrder.customerPhone = event.target.value;
        // this.setState({dataOrder: dataOrder});
    }

    handleCustomerNameChange = (event) => {
        let dataOrder = {...this.state.dataOrder};
        dataOrder.customerName = event.target.value;
        this.setState({dataOrder: dataOrder});
    }

    handleMemberStatusChange = (event) => {
        let dataOrder = {...this.state.dataOrder};
        dataOrder.memberStatus = event.target.value;
        this.setState({dataOrder: dataOrder});
    }

    handleCustomerTypesChange = (event) => {
        let dataOrder = {...this.state.dataOrder};
        dataOrder.customerType = event.target.value;
        this.setState({dataOrder: dataOrder});
    }

    handleCustomerGenderChange = (event) => {
        let dataOrder = {...this.state.dataOrder};
        dataOrder.customerGender = event.target.value;
        this.setState({dataOrder: dataOrder});
    }

    handleJenisPertanyaanChange = (event) => {
        let dataOrder = {...this.state.dataOrder};
        dataOrder.jenisPertanyaan = event.target.value;

        let findQuestion = this.JENIS_PERTANYAAN.find(item => item.question === dataOrder.jenisPertanyaan);

        if(findQuestion){
            dataOrder.levelCustomer = findQuestion.parent;
        }

        this.setState({dataOrder: dataOrder});
    }

    handleLevelCustomerChange = (event) => {
        let dataOrder = {...this.state.dataOrder};
        dataOrder.levelCustomer = event.target.value;
        this.setState({dataOrder: dataOrder});
    }

    handleJawabanCustomerChange = (event) => {
        let dataOrder = {...this.state.dataOrder};
        dataOrder.jawabanCustomer = event.target.value;
        this.setState({dataOrder: dataOrder});
    }

    handleKesimpulanJawabanCustomerChange = (event) => {
        let dataOrder = {...this.state.dataOrder};
        dataOrder.kesimpulanJawabanCustomer = event.target.value;
        this.setState({dataOrder: dataOrder});
    }

    init = () => {
        let dataProfile = {...this.state.dataOrder};
        dataProfile.customerPhone = this.props.waNumber;
        dataProfile.jawabanCustomer = this.props.messageText;
        this.setState({dataOrder: dataProfile}, () => {
            this.loadCustomerInfo();
            this.loadCustomerQna();
            this.listRekomendasiHsm();
            this.loadlastOrderDocuments();
        })
    }

    componentDidMount() {
        this.init();
    }

    handleOpenHsmList = (hsmNameReadable = "") => {
        this.setState({}, () => {
            this.props.handleOpenHsmList(hsmNameReadable);
        });
    }

    listRekomendasiHsm = () => {
        let list = [
            {
                h_min: "H-0",
                buttons: [
                    <Button sx={{mb: "5px"}} size='small' fullWidth variant='outlined' onClick={() =>this.handleOpenHsmList("fu_retention_2025_pertama")}>Fu Retention 2025 Pertama</Button>,
                    <Button sx={{mb: "5px"}} size='small' fullWidth variant='outlined' onClick={() =>this.handleOpenHsmList("fu_retention_2025_kedua")}>Fu Retention 2025 Kedua</Button>,
                    <Button sx={{mb: "5px"}} size='small' fullWidth variant='outlined' onClick={() =>this.handleOpenHsmList("fu_retention_2025_ketiga")}>Fu Retention 2025 Ketiga</Button>,
                ]
            },
            {
                h_min: "H-1",
                buttons: [
                    <Button sx={{mb: "5px"}} size='small' fullWidth variant='outlined' onClick={() =>this.handleOpenHsmList("fu_retention_2025_keempat")}>Fu Retention 2025 Keempat</Button>,
                    <Button sx={{mb: "5px"}} size='small' fullWidth variant='outlined' onClick={() =>this.handleOpenHsmList("fu_retention_2025_kelima")}>Fu Retention 2025 Kelima</Button>
                ]
            },
            {
                h_min: "H-3",
                buttons: [
                    <Button sx={{mb: "5px"}} size='small' fullWidth variant='outlined' onClick={() => this.handleOpenHsmList("fu_retention_2025_keenam")}>Fu Retention 2025 Keenam</Button>,
                    <Button sx={{mb: "5px"}} size='small' fullWidth variant='outlined' onClick={() => this.handleOpenHsmList("fu_retention_2025_ketujuh")}>Fu Retention 2025 Ketujuh</Button>
                ]
            },
            {
                h_min: "H-7",
                buttons: [
                    <Button sx={{mb: "5px"}} size='small' fullWidth variant='outlined' onClick={() =>this.handleOpenHsmList("fu_retention_2025_kedelapan")}>Fu Retention 2025 Kedelapan</Button>
                ]
            },
        ];

        let currentConv = this.props.currentConversation;
        console.log("RESULT_BUTTONS_CONV", currentConv);

        let result = [];
        let hMinValue = "";
        if(currentConv && currentConv.deliveryDate){
            let now = moment().tz("asia/jakarta");
            let deliveryDate = moment(currentConv.deliveryDate).tz("asia/jakarta");
            let deltaInHours = moment.duration(deliveryDate.diff(now)).asHours();

            if(deltaInHours > 0 && deltaInHours <= 48){//H-1
                hMinValue = "H-1";
            }else if(deltaInHours > 0 && deltaInHours <= 96){//H-3
                hMinValue = "H-3";
            }else if(deltaInHours > 0 && deltaInHours <= 192){//H-7
                hMinValue = "H-7";
            }else if(deltaInHours <= 0){
                hMinValue = "H-0";
            }

            result = list.filter(item => item.h_min === hMinValue);
            result = result.length > 0 ? result[0].buttons : [];
            // return result.length > 0 ? result[0].buttons : [];
            
        }

        this.setState({listRekomendasiHsm: result, hMinValue: hMinValue}, () => {
            console.log("RESULT_BUTTONS", result);
        });

        // return [];

    };

    render() {
        const {
            dataOrder,
            isLoadingCustomerInfo,
            lastOrderInfo,
            lastOrderDocuments,
            isLoadingLastOrderDocuments,
            listQna,
            isLoadingCustomerQna,
            customerLevel,
            customerAnsweredQna,
            isSubmitting,
            showSnackbar,
            snackbarMessage,
            isDialogNotFoundOpen,
            showDialogSubmitSuccess,
        } = this.state;

        return (
            <Box sx={{height: "100%", display: "flex", flexDirection: "column", backgroundColor: "#f4f5f7", pb: "30px"}}>
                <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                    sx={{px: 2, py: 1.25, backgroundColor: "#fff", borderBottom: "1px solid #e5e7eb", position: "sticky", top: 0, zIndex: 2}}
                >
                    <Stack direction="row" spacing={1} alignItems="center">
                        <AccountCircle color="primary" />
                        <Typography variant="subtitle1" fontWeight={700}>Customer Profile</Typography>
                    </Stack>
                    <IconButton size="small" onClick={this.props.onCloseDrawer}>
                        <Close fontSize="small" />
                    </IconButton>
                </Stack>

                <Box sx={{flex: 1, overflowY: "auto", px: 1.5, py: 1.5}}>
                    {
                        isLoadingCustomerInfo &&
                        <Paper variant="outlined" sx={{p: 3, borderRadius: 2, textAlign: "center"}}>
                            <CircularProgress size={22} sx={{mb: 1.5}} />
                            <Typography variant="body2" color="text.secondary">
                                Sedang meminta informasi profile dari Lavender ...
                            </Typography>
                        </Paper>
                    }

                    {
                        (dataOrder.customerId <= 0 && !isLoadingCustomerInfo) &&
                        <Alert severity="warning" sx={{borderRadius: 2}}>
                            <Typography variant="body2">
                                Customer dengan email <strong>{dataOrder.customerEmail}</strong> dan phone{" "}
                                <strong>{Global.maskPhoneNumber(dataOrder.customerPhone)}</strong> tidak ditemukan di Lavender.
                            </Typography>
                            <Typography variant="caption" color="text.secondary" display="block" sx={{mt: 1}}>
                                Form ini hanya untuk customer yang sudah ada di lavender.
                            </Typography>
                        </Alert>
                    }

                    {
                        (dataOrder.customerId > 0 && !isLoadingCustomerInfo) &&
                        <Stack spacing={1.5}>
                            <Alert severity="info" variant="outlined" sx={{borderRadius: 2}}>
                                Pastikan isi form profile customer dengan benar, karena akan direview oleh supervisor dan manager operations
                            </Alert>

                            {/* DEV-1222 - tanda customer juga tampil di Lotus WA (permintaan Octa, bukan cuma Live Chat) */}
                            <Paper variant="outlined" sx={{px: 2, pt: 1, borderRadius: 2}}>
                                <CustomerFlagCard phone={this.props.waNumber} />
                            </Paper>

                            <Paper variant="outlined" sx={{p: 2, borderRadius: 2}}>
                                <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{mb: 1}}>
                                    <Stack direction="row" spacing={1} alignItems="center">
                                        <ReceiptLong fontSize="small" color="action" />
                                        <Typography variant="subtitle2" fontWeight={700}>Last Order Info</Typography>
                                    </Stack>
                                    <Stack alignItems="center">
                                        <Typography variant="caption" color="text.secondary">Points</Typography>
                                        <Chip size='small' color='primary' label={dataOrder?.points ? `${dataOrder?.points?.toLocaleString("id-ID")}` : "0"} />
                                    </Stack>
                                </Stack>
                                <Divider sx={{mb: 1.5}} />

                                {
                                    lastOrderInfo ? (
                                        <Box>
                                            <Box textAlign="center" sx={{mb: 1.5}}>
                                                <Avatar
                                                    variant="rounded"
                                                    src={`${Api.getLavenderUrl()}/${lastOrderInfo?.cartLast?.image}?w=248&fit=crop&auto=format`}
                                                    sx={{width: 96, height: 96, mx: "auto", mb: 1}}
                                                />
                                                <Chip size='small' label={lastOrderInfo?.cartLast?.product_code} variant='outlined' />
                                            </Box>

                                            <Grid container spacing={1.5}>
                                                <Grid item xs={4} sx={{textAlign: "center"}}>
                                                    <Typography variant="caption" color="text.secondary" display="block">Nama Pengirim</Typography>
                                                    <Typography variant="body2" fontWeight={600}>{lastOrderInfo?.cartLast?.sender_name || "-"}</Typography>
                                                </Grid>
                                                <Grid item xs={4} sx={{textAlign: "center"}}>
                                                    <Typography variant="caption" color="text.secondary" display="block">Pembayaran</Typography>
                                                    <Typography variant="body2" fontWeight={600}>{lastOrderInfo?.payment_type || "-"}</Typography>
                                                </Grid>
                                                <Grid item xs={4} sx={{textAlign: "center"}}>
                                                    <Typography variant="caption" color="text.secondary" display="block">Tax Type</Typography>
                                                    <Typography variant="body2" fontWeight={600}>{lastOrderInfo?.tax_type || "-"}</Typography>
                                                </Grid>
                                                <Grid item xs={4} sx={{textAlign: "center"}}>
                                                    <Typography variant="caption" color="text.secondary" display="block">Nomor CO</Typography>
                                                    <Button
                                                        size='small'
                                                        variant='text'
                                                        target="_blank"
                                                        href={`https://sakura.prestisa.id/orders/view/${lastOrderInfo?.order_number}`}
                                                        endIcon={<OpenInNew sx={{width: "10px", height: "10px"}} />}
                                                        sx={{fontSize: "11px", textTransform: "none"}}
                                                    >
                                                        {lastOrderInfo?.order_number}
                                                    </Button>
                                                </Grid>
                                                <Grid item xs={4} sx={{textAlign: "center"}}>
                                                    <Typography variant="caption" color="text.secondary" display="block">Harga Non Tax</Typography>
                                                    <Typography variant="body2" fontWeight={600}>
                                                        {new Intl.NumberFormat('id-ID', {}).format(lastOrderInfo?.total,)}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={4} sx={{textAlign: "center"}}>
                                                    <Typography variant="caption" color="text.secondary" display="block">Qty</Typography>
                                                    <Typography variant="body2" fontWeight={600}>{lastOrderInfo?.cartLast?.qty}</Typography>
                                                </Grid>
                                                {/* DEV-1426 */}
                                                <Grid item xs={12} sx={{textAlign: "center"}}>
                                                    <Typography variant="caption" color="text.secondary" display="block" sx={{mb: 0.5}}>Sub Order</Typography>
                                                    <SubOrderChip subOrder={lastOrderInfo?.sub_order} />
                                                </Grid>
                                            </Grid>
                                        </Box>
                                    ) : (
                                        <Typography variant="body2" color="text.secondary" textAlign="center" sx={{py: 2}}>
                                            Belum ada informasi order
                                        </Typography>
                                    )
                                }
                            </Paper>

                            <Paper variant="outlined" sx={{p: 2, borderRadius: 2}}>
                                <Stack direction="row" spacing={1} alignItems="center" sx={{mb: 1}}>
                                    <Description fontSize="small" color="action" />
                                    <Typography variant="subtitle2" fontWeight={700}>Company Documents</Typography>
                                </Stack>
                                <Divider sx={{mb: 1.5}} />

                                {
                                    isLoadingLastOrderDocuments && (<LinearProgress sx={{mb: 1}} />)
                                }

                                {
                                    lastOrderDocuments?.map((item, docIdx) => {
                                        let urlDesign = `${Api.getLavenderUrl()}/${item.special_request_image}`;
                                        let urlLogo = `${Api.getLavenderUrl()}/${item.special_request_logo}`;
                                        let urlNpwp = `${Api.getLavenderUrl()}/${item.npwp_img}`;
                                        let hasNpwpText = !!item.npwp_number;

                                        if(!item.special_request_image && !item.special_request_logo && !item.npwp_img && !hasNpwpText){
                                            return (
                                                <Typography key={docIdx} variant="body2" color="text.secondary" textAlign="center" sx={{py: 2}}>
                                                    Belum ada dokumen
                                                </Typography>
                                            );
                                        }

                                        return (
                                            <Grid container spacing={1.5} key={docIdx}>
                                                {
                                                    item.special_request_image && (
                                                        <Grid item xs={4}>
                                                            <Typography variant="caption" color="text.secondary" display="block" textAlign="center" sx={{mb: 0.5}}>Desain</Typography>
                                                            <ImageZoom
                                                                image={{ src: urlDesign, alt: '', className: 'doc-images' }}
                                                                zoomImage={{ src: urlDesign, alt: '' }}
                                                            />
                                                        </Grid>
                                                    )
                                                }
                                                {
                                                    item.special_request_logo && (
                                                        <Grid item xs={4}>
                                                            <Typography variant="caption" color="text.secondary" display="block" textAlign="center" sx={{mb: 0.5}}>Logo</Typography>
                                                            <ImageZoom
                                                                image={{ src: urlLogo, alt: '', className: 'doc-images' }}
                                                                zoomImage={{ src: urlLogo, alt: '' }}
                                                            />
                                                        </Grid>
                                                    )
                                                }
                                                {
                                                    hasNpwpText ? (
                                                        <Grid item xs={4}>
                                                            <Typography variant="caption" color="text.secondary" display="block" textAlign="center" sx={{mb: 0.5}}>NPWP</Typography>
                                                            <Box className="doc-images" sx={{p: 1, border: "1px solid #e5e7eb", borderRadius: 1, fontSize: 11}}>
                                                                <div><strong>NPWP:</strong> {item.npwp_number}</div>
                                                                <div><strong>Nama:</strong> {item.npwp_name}</div>
                                                                <div><strong>Alamat:</strong> {item.npwp_address}</div>
                                                            </Box>
                                                        </Grid>
                                                    ) : item.npwp_img && (
                                                        <Grid item xs={4}>
                                                            <Typography variant="caption" color="text.secondary" display="block" textAlign="center" sx={{mb: 0.5}}>NPWP</Typography>
                                                            <ImageZoom
                                                                image={{ src: urlNpwp, alt: '', className: 'doc-images' }}
                                                                zoomImage={{ src: urlNpwp, alt: '' }}
                                                            />
                                                        </Grid>
                                                    )
                                                }
                                            </Grid>
                                        );
                                    })
                                }
                            </Paper>

                            <Paper variant="outlined" sx={{p: 2, borderRadius: 2}}>
                                <Stack direction="row" spacing={1} alignItems="center" sx={{mb: 1}}>
                                    <QuestionAnswer fontSize="small" color="action" />
                                    <Typography variant="subtitle2" fontWeight={700}>Approved Question And Answer</Typography>
                                </Stack>
                                <Divider sx={{mb: 1.5}} />

                                {
                                    isLoadingCustomerQna &&
                                    <Box textAlign="center" sx={{py: 2}}>
                                        <LinearProgress sx={{mb: 1}} />
                                        <Typography variant="body2" color="text.secondary">Loading informasi QnA ...</Typography>
                                    </Box>
                                }

                                {
                                    !isLoadingCustomerQna && listQna?.length > 0 &&
                                    <TableContainer>
                                        <Table size='small'>
                                            <TableBody>
                                                {
                                                    listQna.map((item, qnaIdx) => (
                                                        <TableRow key={qnaIdx}>
                                                            <TableCell sx={{fontWeight: "bold", backgroundColor: "#F1F2F4", width: "35%"}}>{item.question}</TableCell>
                                                            <TableCell>{item.conclusion}</TableCell>
                                                        </TableRow>
                                                    ))
                                                }
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                }

                                {
                                    !isLoadingCustomerQna && listQna?.length <= 0 &&
                                    <Typography variant="body2" color="text.secondary" textAlign="center" sx={{py: 2}}>
                                        Informasi QnA belum tersedia
                                    </Typography>
                                }
                            </Paper>

                            <Paper variant="outlined" sx={{p: 2, borderRadius: 2}}>
                                <Stack direction="row" spacing={1} alignItems="center" sx={{mb: 1}}>
                                    <Assignment fontSize="small" color="action" />
                                    <Typography variant="subtitle2" fontWeight={700}>Customer Profile Form</Typography>
                                </Stack>
                                <Typography variant="caption" color="text.secondary" display="block" sx={{mb: 1.5}}>
                                    Autofill hanya bisa digunakan untuk 1 item produk tiap 1 CO
                                </Typography>
                                <Divider sx={{mb: 1.5}} />

                                <Stack spacing={1.5}>
                                    <FormControl fullWidth size='small'>
                                        <InputLabel id="select-jenis-pertanyaan">Jenis Pertanyaan</InputLabel>
                                        <Select
                                            labelId="select-jenis-pertanyaan"
                                            id="select-jenis-pertanyaan"
                                            value={dataOrder.jenisPertanyaan}
                                            label="Jenis Pertanyaan"
                                            onChange={this.handleJenisPertanyaanChange}
                                        >
                                            {
                                                this.getJenisPertanyaan()?.map((item, itemIdx) => (
                                                    <MenuItem key={itemIdx} value={item.question}>{item.question}</MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </FormControl>
                                    <FormControl fullWidth size='small' disabled>
                                        <InputLabel id="select-level-customer">Member Status</InputLabel>
                                        <Select
                                            labelId="select-level-customer"
                                            id="select-level-customer"
                                            value={dataOrder.levelCustomer}
                                            label="Member Status"
                                            onChange={this.handleLevelCustomerChange}
                                        >
                                            {
                                                this.LEVEL_CUSTOMER.map((item, levelIdx) => (
                                                    <MenuItem key={levelIdx} value={item}>{item}</MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </FormControl>
                                    <TextField
                                        error={false}
                                        id="txt-jawaban-customer"
                                        label="Jawaban Customer"
                                        value={dataOrder.jawabanCustomer}
                                        onChange={this.handleJawabanCustomerChange}
                                        helperText=""
                                        fullWidth
                                        disabled
                                        required
                                        size='small'
                                        type='text'
                                        multiline
                                    />
                                    <FormControl fullWidth size='small'>
                                        <InputLabel id="select-kesimpulan-jawaban">Kesimpulan Jawaban Customer</InputLabel>
                                        <Select
                                            labelId="select-kesimpulan-jawaban"
                                            id="select-kesimpulan-jawaban"
                                            value={dataOrder.kesimpulanJawabanCustomer}
                                            label="Kesimpulan Jawaban Customer"
                                            onChange={this.handleKesimpulanJawabanCustomerChange}
                                        >
                                            {
                                                Global.kesimpulanJawabanCustomer.map((item, kesimpulanIdx) => (
                                                    <MenuItem key={kesimpulanIdx} value={item}>{item}</MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </FormControl>

                                    {
                                        isSubmitting === true ?
                                            (<LinearProgress />) :
                                            (<Button variant='contained' fullWidth onClick={this.handleProceed} sx={{textTransform: "none"}}>Submit</Button>)
                                    }
                                </Stack>
                            </Paper>

                            <Paper variant="outlined" sx={{p: 2, borderRadius: 2, mb: 2}}>
                                <Stack direction="row" spacing={1} alignItems="center" sx={{mb: 1}}>
                                    <AccountCircle fontSize="small" color="action" />
                                    <Typography variant="subtitle2" fontWeight={700}>Customer Information</Typography>
                                </Stack>
                                <Divider sx={{mb: 1.5}} />

                                <Grid container spacing={1.5}>
                                    <Grid item xs={6}>
                                        <Stack spacing={1.5}>
                                            <TextField
                                                error={false}
                                                id="txt-cust-email"
                                                label="Customer Email"
                                                value={dataOrder.customerEmail}
                                                onChange={this.handleCustomerEmailChange}
                                                helperText=""
                                                fullWidth
                                                required
                                                size='small'
                                                type='email'
                                                disabled
                                            />
                                            <TextField
                                                error={false}
                                                id="txt-cust-phone"
                                                label="Customer Phone"
                                                value={Global.maskPhoneNumber(dataOrder.customerPhone)}
                                                onChange={this.handleCustomerPhoneChange}
                                                helperText=""
                                                fullWidth
                                                required
                                                size='small'
                                                type='phone'
                                                disabled
                                            />
                                            <TextField
                                                error={false}
                                                id="txt-cust-name"
                                                label="Customer Name"
                                                value={dataOrder.customerName}
                                                onChange={this.handleCustomerNameChange}
                                                helperText=""
                                                fullWidth
                                                required
                                                size='small'
                                                disabled
                                            />
                                            <TextField
                                                error={false}
                                                id="txt-cust-level"
                                                label="Level Customer"
                                                value={customerLevel}
                                                helperText=""
                                                fullWidth
                                                required
                                                size='small'
                                                disabled
                                            />
                                        </Stack>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Stack spacing={1.5}>
                                            <FormControl fullWidth size='small' disabled>
                                                <InputLabel id="select-member-status">Member Status</InputLabel>
                                                <Select
                                                    labelId="select-member-status"
                                                    id="select-member-status"
                                                    value={dataOrder.memberStatus}
                                                    label="Member Status"
                                                    onChange={this.handleMemberStatusChange}
                                                >
                                                    {
                                                        this.MEMBER_STATUS.map((item) => (
                                                            <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
                                                        ))
                                                    }
                                                </Select>
                                            </FormControl>
                                            <FormControl fullWidth size='small' disabled>
                                                <InputLabel id="select-customer-type">Customer Type</InputLabel>
                                                <Select
                                                    labelId="select-customer-type"
                                                    id="select-customer-type"
                                                    value={dataOrder.customerType}
                                                    label="Customer Type"
                                                    onChange={this.handleCustomerTypesChange}
                                                >
                                                    {
                                                        this.CUSTOMER_TYPES.map((item) => (
                                                            <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
                                                        ))
                                                    }
                                                </Select>
                                            </FormControl>
                                            <FormControl fullWidth size='small' disabled required>
                                                <InputLabel id="select-customer-gender">Customer Gender</InputLabel>
                                                <Select
                                                    labelId="select-customer-gender"
                                                    id="select-customer-gender"
                                                    value={dataOrder.customerGender}
                                                    label="Customer Gender"
                                                    onChange={this.handleCustomerGenderChange}
                                                >
                                                    {
                                                        this.GENDER.map((item) => (
                                                            <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
                                                        ))
                                                    }
                                                </Select>
                                            </FormControl>
                                            <TextField
                                                error={false}
                                                id="txt-question-answered"
                                                label="Pertanyaan Terjawab"
                                                value={customerAnsweredQna}
                                                onChange={this.handleCustomerNameChange}
                                                helperText=""
                                                fullWidth
                                                required
                                                size='small'
                                                disabled
                                            />
                                        </Stack>
                                    </Grid>
                                </Grid>
                            </Paper>
                            {dataOrder.customerId > 0 && (
                                <PoinCheckoutLinkSection customerId={dataOrder.customerId} />
                            )}
                        </Stack>
                    }
                </Box>

                <Snackbar
                    open={showSnackbar}
                    onClose={() => {this.setState({showSnackbar: false})}}
                    message={snackbarMessage}
                    autoHideDuration={6000}
                />
                <Dialog
                    open={isDialogNotFoundOpen}
                    onClose={this.toggleDialogNotFound}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title" sx={{display: "flex", alignItems: "center", gap: 1}}>
                        <WarningAmber color="warning" />
                        Konfirmasi
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Customer dengan email <strong>{dataOrder.customerEmail}</strong> dan phone{" "}
                            <strong>{Global.maskPhoneNumber(dataOrder.customerPhone)}</strong> tidak ditemukan di Lavender.
                        </DialogContentText>
                        <Typography variant="caption" color="text.secondary" display="block" sx={{mt: 1.5}}>
                            <strong>Note:</strong> Form ini hanya untuk customer yang sudah ada di lavender
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.toggleDialogNotFound}>Tutup</Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={showDialogSubmitSuccess}
                    onClose={this.toggleDialogSubmitSuccess}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title" sx={{display: "flex", alignItems: "center", gap: 1}}>
                        <CheckCircle color="success" />
                        Berhasil
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Submission informasi customer berhasil dan akan segera direview
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.toggleDialogSubmitSuccess}>Tutup</Button>
                    </DialogActions>
                </Dialog>
            </Box>
        );
    }
}
 
export default CustomerProfile;